import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cn } from '../utils/cn';
/** Innenabstand-Bereich innerhalb einer Card (MUI-`CardContent`-Ersatz). */
export const CardContent = forwardRef(function CardContent({ className, ...rest }, ref) {
    return _jsx("div", { ref: ref, className: cn('sec-card-content', className), ...rest });
});
